import React from "react";
import { PartnerCard } from "./ui/partner-card";
import { Flex } from "@radix-ui/themes";
import { BlueField } from "./ui/blue-field";

export function OGTSU() {
  return (
    <PartnerCard
      logo={
        <img
          className="partner-logo"
          src="/Images/barometer/partners/ogtsu_logo.jpg"
          alt="partner logo"
        />
      }
      heading="Експертний партнер"
    >
      <Flex direction="column" gap="5">
        <p>
          <BlueField>
            Оператор ГТС України — одна з ключових енергетичних компаній країни,
          </BlueField>{" "}
          що управляє однією з найбільших газотранспортних систем Європи (понад
          33 тис. км трубопроводів, компресорні станції, газовимірювальні та
          газорозподільчі пункти).
        </p>

        <p>
          Компанія забезпечує безперебійне постачання газу в Україні та транзит
          до країн ЄС, зміцнюючи енергетичну незалежність держави.
        </p>

        <p>
          <BlueField>
            З 2020 року ОГТСУ — сертифікований та незалежний оператор, що працює
            за європейськими стандартами прозорості й відкритості.
          </BlueField>{" "}
          Компанія модернізує інфраструктуру, впроваджує цифрові рішення та
          готується до транспортування водню.
        </p>

        <p>
          В ОГТСУ працює{" "}
          <BlueField>майже 9 000 фахівців у 75 професіях.</BlueField> Компанія
          створює умови для розвитку персоналу, підтримує ветеранів та активно
          залучає молодь через програми стажувань.
        </p>

        <p>
          ОГТСУ — стратегічний елемент енергетичної безпеки та сучасний
          роботодавець, який робить внесок у сталий розвиток України.
        </p>
      </Flex>
    </PartnerCard>
  );
}
